import { render, staticRenderFns } from "./cateTree.vue?vue&type=template&id=589930f5&"
import script from "./cateTree.vue?vue&type=script&lang=js&"
export * from "./cateTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports